import { firebaseApp } from "firebase/config";

export const firebaseAnalytics = firebaseApp.analytics();
